import { Button, styled } from "@mui/material";

/**
 * GradientButton – with Lexend font and
 * linear gradient (#6366F1 → #9F03FF).
 */
export const GradientButton = styled(Button)(({ theme }) => ({
  fontFamily: '"Lexend", sans-serif', // Make sure Lexend is loaded
  background: "linear-gradient(90deg, #6366F1 0%, #9F03FF 100%)",
  color: "#fff",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.4, 3),
  "&:hover": {
    background: "linear-gradient(90deg, #6366F1 0%, #9F03FF 100%)",
    boxShadow: "0 4px 14px rgba(99, 102, 241, 0.3)", // optional hover shadow
  },
}));


export const GradientButton_ = styled(Button)(({ theme }) => ({
  fontFamily: '"Lexend", sans-serif', // Make sure Lexend is loaded
  
  color: "#fff",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.4, 3),
  "&:hover": {
    background: "linear-gradient(90deg, #6366F1 0%, #9F03FF 100%)",
    boxShadow: "0 4px 14px rgba(99, 102, 241, 0.3)", // optional hover shadow
  },
}));